import { OperatorType } from '@fulcrumapp/query-sql';
// @ts-ignore
export default function findOperator(key: string): OperatorType | null {
  const operatorTypeKeys = Object.keys(OperatorType);
  for (let x = 0; x < operatorTypeKeys.length; x += 1) {
    const operatorTypeKey = operatorTypeKeys[x];
    const operatorType = OperatorType[operatorTypeKey];
    if (operatorType.name === key || operatorType.label === key) {
      return operatorType;
    }
  }
  return null;
}
